import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import HFNewsSider from './hfNewsSider';
import HFNews from './hfNews';

class HomeAndFood extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { houseAreaMap, hfNewsSiderData, hfNewsData },
        } = this.props;
        let city = null;
        let houseAreaData = {};

        if (typeof document !== 'undefined') {
            city =
                cookie.get('city') && cookie.get('city') !== '' && cookie.get('city') !== '010'
                    ? cookie.get('city')
                    : null;

            for (const item of houseAreaMap) {
                if (item.city === city) houseAreaData = item;
            }
        }

        return (
            <div className={styles.box}>
                <NoSSR>
                    <HFNewsSider content={hfNewsSiderData} />
                </NoSSR>
                <HFNews
                    content={hfNewsData}
                    listOne={houseAreaData.listOne}
                    listTwo={houseAreaData.listTwo}
                    isGZ={city === '020'}
                />
            </div>
        );
    }
}

export default errorBoundary(HomeAndFood);
